@use '../@shared/mixins' as *;
@use '../@shared/global' as *;
@use '../@shared/link.mixin' as *;

@layer kol-component {
	@include kol-link-styles('kol-link');
}
